import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { ui } from 'components';

import './style.scss';

const FiltersForm = ({
  fields,
  label,
  filters,
  single,
}) => (
  <div className="filters-form">
    <div className="filters-form__fields">
      {fields.map((filter, i) => (
        <Field
          key={i}
          name={filter}
          component={ui.Fields.DropdownField}
          props={{
            label,
            filters,
          }}
        />
      ))}
    </div>
    {!single ?
      <div className="filters-form__add">
        <ui.Buttons.BaseButton
          title="+"
          style={{ marginRight: '10px' }}
          onClick={(e) => {
            e.preventDefault();
            fields.push();
          }}
        />
        <ui.Buttons.BaseButton
          title="-"
          onClick={(e) => {
            e.preventDefault();
            fields.pop();
          }}
        />
      </div> : null}
  </div>
);

FiltersForm.propTypes = {
  fields: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  single: PropTypes.bool.isRequired,
};

FiltersForm.defaultProps = {
  single: false,
};

export default FiltersForm;



// WEBPACK FOOTER //
// ./src/components/forms/AddProductForm/FiltersForm/index.js